import React from "react";

export function Button({ extraClasses, onClick, children, disabled }) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`font-body text-base border py-1 px-8 uppercase${
        extraClasses ? " " + extraClasses : ""
      }`}
    >
      {children}
    </button>
  );
}

export function FormGroup({ children }) {
  return (
    <div className="flex flex-col w-full md:w-1/2 px-6 mb-4">{children}</div>
  );
}

export function Label({ children, htmlFor }) {
  return (
    <label htmlFor={htmlFor} className="text-base font-body">
      {children}
    </label>
  );
}

export function Input({ type, id, onChange }) {
  return (
    <input
      type={type}
      id={id}
      className="border border-solid border-gray rounded text-base font-body py-1 px-2"
      onChange={onChange}
    />
  );
}

export function ControlledSelect({ id, options, value, onChange }) {
  return (
    <select
      id={id}
      className="border border-solid border-gray rounded text-base font-body h-10 py-1 px-2"
      value={value}
      onChange={onChange}
      onBlur={onChange}
    >
      {options.map((opt, idx) => {
        return (
          <option key={idx} value={opt.value}>
            {opt.label}
          </option>
        );
      })}
    </select>
  );
}
